import PropTypes from 'prop-types';
import { get, omit, mapValues } from 'lodash';

const banks = ['CB', 'YB', 'B'];
export const createContent = (content, bank) => omit(Object.assign(content, content[bank]), banks);

export default (content, bank, key) => {
	const flattenedContent = createContent(content, bank);
	return get(flattenedContent, key) || '';
};

export const createContentPropTypes = (content) =>
	mapValues(omit(content, banks), (value) => {
		if (Array.isArray(value)) {
			return PropTypes.arrayOf(PropTypes.string);
		}
		return PropTypes.string;
	});

export const bacsLimitFrequencyMap = {
	Daily: 'per day',
	Weekly: 'per week',
	Fortnightly: 'per fortnight',
	Four_Weekly: 'per four weeks',
	Monthly: 'per month',
	Quarterly: 'per quarter',
};
